import { StarsButton } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import StarsModal from '@swf/components/StarsModal/StarsModal';
import type { Dispatch } from '@swf/core/store';

interface Props {
  route: string;
  locationState?: object;
  buttonFirst?: boolean;
}

const ModalRenderer: React.FC<Props> = ({ route, locationState = {}, buttonFirst = false }) => {
  const { modal } = useDispatch<Dispatch>();

  useEffect(() => {
    if (!buttonFirst) {
      modal.unique({ path: route, locationState });
    }
  }, [buttonFirst, locationState, modal, route]);

  return (
    <>
      <StarsButton
        onClick={() => modal.unique({ path: route, locationState })}
        translation={{ id: 'Open Modal', defaultMessage: 'Open Modal', track: 'OpenModal' }}
      />
      <StarsModal />
    </>
  );
};
export default ModalRenderer;
